<template>
    <section>
        <canvas ref="barChart"></canvas>
    </section>
</template>

<script>
    import Chart from 'chart.js'

    export default {
        name: 'DominantColor',
        props: {
            data: {
                default: () => [],
                type: Array
            }
        },
        data () {
            return {
                barChart: null
            }
        },
        watch: {
            data (data) {
                this.drawBarChart()
            }
        },
        methods: {
            drawBarChart () {
                const ctx = this.$refs.barChart
                const max02 = _.max(this.data.map(x => x[1] / x[2])) * -0.2
                let dataPack1 = this.data.map(x => max02)
                let dataPack2 = this.data.map(x => x[1] / x[2])
                let dates = this.data.map(x => "")
                this.barChart = new Chart(ctx, {
                        type: 'bar',
                        data: {
                            labels: dates,
                            datasets: [
                                {
                                    label: '',
                                    data: dataPack1,
                                    backgroundColor: "#512DA8",
                                    hoverBackgroundColor: "#7E57C2",
                                    hoverBorderWidth: 0
                                },
                                {
                                    label: 'Avg. Engagement per Post',
                                    data: dataPack2,
                                    backgroundColor: "#c0c0c0",
                                    hoverBackgroundColor: "#e3e1e1",
                                    hoverBorderWidth: 0
                                }
                            ]
                        },
                        options: {
                            animation: {
                                duration: 10,
                            },
                            tooltips: {
                                enabled: false,
                                callbacks: {
                                    label: function(tooltipItem, data) {
                                        return data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel;
                                    }
                                }
                            },
                            scales: {
                                xAxes: [{
                                    stacked: true,
                                    gridLines: { display: false },
                                }],
                                yAxes: [{
                                    stacked: true,
                                    gridLines: { display: false },

                                    ticks: {
                                        callback: function(value) { return ''; },
                                    },
                                }],
                            }, // scales
                            legend: {display: false}
                        } // options
                    }
                )
                for (let i in this.data) {
                    const color = "hsl(" + this.data[i][0] + ",80%,61%)"
                    const colorh = "hsl(" + this.data[i][0] + ",80%,81%)"
                    this.barChart.getDatasetMeta(0)
                        .data[i].custom = {
                        backgroundColor: color,
                        hoverBackgroundColor: colorh
                    };
                }
                this.barChart.update();
            }
        }
    }
</script>

<style scoped>

</style>
